
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/badges",
      function () {
        return require("private-next-pages/components/badges.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/badges"])
      });
    }
  